import ConversationItem from '../../models/conversation_item';
import Communicator from '../../models/communicator';
import ConversationNote from '../../models/conversation_note';

export default function createConversationNoteItem({
  agentProfile,
  content,
  conversationId,
  customerId,
  snippetIds = [],
  relatedSnippetIds = [],
}) {
  return ConversationItem.create({
    conversationId,
    content: ConversationNote.create(content),
    customerId,
    initiator: {
      id: agentProfile.id,
      type: Communicator.AGENT,
    },
    snippetIds,
    relatedSnippetIds,
  });
}



// WEBPACK FOOTER //
// ./src/scripts/domain/factories/conversation_item/create_conversation_note_item.js